import { ReportDownloadError } from './report-download-error.interface';

const STATUS_NOT_READY = 409;
const STATUS_EXPIRED = 410;
const STATUS_FORBIDDEN = 403;

/**
 * No file yet: the run is still running or failed, or the file lags behind
 * the Succeeded milestone. The list must be reloaded.
 */
export function isFileNotReady(failure: ReportDownloadError): boolean {
  return failure.status === STATUS_NOT_READY;
}

/** The file is gone after the retention period; a restart creates a new one. */
export function isFileExpired(failure: ReportDownloadError): boolean {
  return failure.status === STATUS_EXPIRED;
}

/** Translation key under `features.users.reports.list.error` for a failed download. */
export function downloadFailureKey(failure: ReportDownloadError): string {
  if (isFileNotReady(failure)) return 'file-pending';
  if (isFileExpired(failure)) return 'expired';
  if (failure.status === STATUS_FORBIDDEN) return 'forbidden';
  return 'download';
}
